import { setupListeners } from '@reduxjs/toolkit/query';

import configureStore from './configureStore';

const store = configureStore();

setupListeners(store.dispatch);

export default store;
